import React, { ComponentProps } from 'react';
import { BlogPostListItem } from './partials/BlogPostListItem';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type BlogPostList = {
  items: BlogPostListItem[];
};

export function BlogPostList({ items = [] }: BlogPostList) {
  if (items?.length === 0) {
    return null;
  }

  return (
    <ol className="blog-post-list">
      {items.map((item, index) => (
        <BlogPostListItem isFirstItem={index === 0} key={`${item.contentDate}-${item.author}`} {...item} />
      ))}
    </ol>
  );
}

export const BlogPostListBlock = asBlock(BlogPostList, BlockType.blogpostlist);
export type BlogPostListBlock = ComponentProps<typeof BlogPostListBlock>;
